/**
 * View for filling in a value
 * Consists of an input field and a preview of the value,
 * formatted according to a given currency and locale
 **/

import BaseView from '../../base-view';
import i18n from '../../utils/i18n';
import Model from './model';

export default BaseView.extend({

	events: {
		'focus .js-decimal-value': 'setValue',
		'input .js-decimal-value': 'updateValue',
		'blur .js-decimal-value': 'setFormattedValue'
	},

	initialize: function() {
		// reference to elements
		this.input = this.query('.js-decimal-value');

		// reference to model
		this.model = this.model || new Model();
	},

	/**
	 * Fill input with unformatted value
	 **/
	setValue: function() {
		var value = this.model.get('value');
		this.input.value = value;
	},

	/**
	 * Fill input with formatted value
	 **/
	setFormattedValue: function() {
		var decimalPlaces = parseInt(this.input.dataset.decimalPlaces);

		var value = this.model.get('value') || 0,
			valueFormatted = i18n.formatNumberAsDecimal(
				parseFloat(value),
				decimalPlaces
			);

		this.input.value = valueFormatted;
	},

	/**
	 * Update value property in model
	 **/
	updateValue: function() {
		this.model.set('value', this.input.value);
	}
});
